import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react'; // Using lucide-react as used in your other project files

const TestimonialBanner = () => {
  return (
    <section className="banner breadcrumb mb-0 pt-11 pb-10 position-relative rounded3 rounded-top-0 bg-darkgreen">
      {/* Overlay to ensure text readability */}
      <div className="overlay rounded3 rounded-top-0 position-absolute w-100 h-100 top-0 start-0 opacity-50 bg-black"></div>
      
      <div className="container position-relative z-index-1">
        <div className="banner-inner pt-10 w-lg-75 m-auto text-center text-white">
          <div className="section-title mb-2">
            <h1 className="text-white mb-2 text-uppercase fw-bold">Testimonials</h1>
            
            <ul className="list-unstyled d-flex justify-content-center align-items-center">
              <li>
                <Link to="/" className="text-white text-decoration-none hover-green">
                  Home
                </Link>
              </li>
              
              <li className="mx-4">
                <Star size={16} className="text-lightgreen" fill="currentColor" />
              </li>
              
              <li>
                <span className="text-lightgreen">Testimonials</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialBanner;